<div *transloco="let t; read: 'base-header'"
  class="content">
  <a class="skip-link"
    href="./#main-content"
    [attr.aria-label]="t('aria_skip_link')"
    (click)="$event.preventDefault(); handleSkip()">{{ t('aria_skip_link') }}</a>
  <div>
    <ng-content select="[identitySection]"></ng-content>
    <ng-content select="[navigationSection]"></ng-content>
  </div>
</div>
